import ReviewQueueTable from "./ReviewQueue_redesign";

export default ReviewQueueTable;
